import { render, staticRenderFns } from "./MoudEditAbout.vue?vue&type=template&id=c5ec7234&scoped=true&"
import script from "./MoudEditAbout.vue?vue&type=script&lang=js&"
export * from "./MoudEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ec7234",
  null
  
)

export default component.exports